import React, { useState } from "react";
import { useForm } from "react-hook-form";
import Loader from "react-loader-spinner";

// services
import { Mixpanel, MixpanelEvents } from "../../../../services/Mixpanel";

// css
import * as styles from "./RegisterForm.module.css";

const FormComponent = props => {
  const [formTouched, setFormTouched] = useState(true);

  const {
    register,
    handleSubmit,
    formState: { errors, isValid, isSubmitted, isDirty },
  } = useForm({ mode: "all" });

  if (isDirty && formTouched) {
    Mixpanel.track(MixpanelEvents.contact_form_started, {
      page_name: props.mixpanelPageName,
      form_is_modal: false,
    });
    setFormTouched(false);
  }

  // Function to handle the form submission
  const onSubmit = data => {
    // Mixapnel Events
    Mixpanel.track(MixpanelEvents.contact_form_completed, {
      page_name: props.mixpanelPageName,
      form_is_modal: false,
      user_name: data.name,
      user_phone: data.phone,
    });

    // Leadsquared Events
    const formData = {
      name: data.name,
      email: data.email,
      phone: data.phone,
    };
    props.formDataToLsq(formData);
  };

  return (
    <>
      <div className={`${styles.diabConsLp__form__border__desk}`}></div>
      <div className={`${styles.diabConsLp__form__hdngCol}`}>
        <div className={`${styles.diabConsLp__form__hdng}`}>
          <h2>{props.formHeading}</h2>
        </div>
        <div className={`${styles.diabConsLp__form__formDiv}`}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row g-3 mb-3">
              <div className={`col-md-12 ${styles.diabConsLp__form__inpBox}`}>
                <input
                  type="text"
                  placeholder="Name*"
                  id="name"
                  className={
                    errors.name ? "form-control is-invalid" : "form-control"
                  }
                  {...register("name", {
                    required: "Please enter your name",
                    pattern: {
                      value: /[a-zA-Z][a-zA-Z ]*/, // eslint-disable-line no-useless-escape
                      message: "Please enter your valid name",
                    },
                    maxLength: {
                      value: 50,
                      message: "Name is too long",
                    },
                  })}
                />
                {errors.name && (
                  <span className="invalid-feedback">
                    {errors.name.message}
                  </span>
                )}
              </div>
              <div className={`col-md-12 ${styles.diabConsLp__form__inpBox}`}>
                <input
                  className={
                    errors.email ? "form-control is-invalid" : "form-control"
                  }
                  placeholder="Email*"
                  id="email"
                  type="email"
                  {...register("email", {
                    required: "Please enter your email id",
                    pattern: {
                      value:
                        /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i, // eslint-disable-line no-useless-escape
                      message: "Please enter your valid email id",
                    },
                  })}
                />
                {errors.email && (
                  <span className="invalid-feedback">
                    {errors.email.message}
                  </span>
                )}
              </div>
              <div className={`col-md-12 ${styles.diabConsLp__form__inpBox}`}>
                <input
                  type="text"
                  placeholder="WhatsApp Number*"
                  id="phoneNumber"
                  inputMode="numeric"
                  maxLength="10"
                  className={`form-control letterSp1 ${
                    errors.phone ? "is-invalid" : ""
                  }`}
                  {...register("phone", {
                    required: "Please enter your mobile number",
                    pattern: {
                      value:
                        /^\+?([1-9]{1})\)?[-. ]?([0-9]{5})[-. ]?([0-9]{4})$/, // eslint-disable-line no-useless-escape
                      message: "Please enter your valid mobile number",
                    },
                    maxLength: {
                      value: 10,
                      message: "Invalid mobile number",
                    },
                  })}
                />
                {errors.phone && (
                  <span className="invalid-feedback">
                    {errors.phone.message}
                  </span>
                )}
              </div>
              <div className="col-12">
                <div className={`form-group mb-3`}>
                  <div className="custom-control">
                    <div className="d-flex align-items-center">
                      <input
                        className={`custom-control-input ${styles.checkbox}`}
                        type="checkbox"
                        defaultChecked={true}
                        id="flexCheckChecked"
                        htmlFor="terms-checkbox"
                        {...register("terms", {
                          required:
                            "Please check contacted by Twin Health via Call, SMS, WhatsApp & Email box",
                        })}
                      />
                      <label
                        className={`custom-control-label ${styles.checkLabel}`}
                        htmlFor="terms-checkbox"
                      >
                        I agree to be contacted by Twin Health via Call, SMS,
                        RCS, WhatsApp & Email
                      </label>
                    </div>
                    {errors.terms && (
                      <span className={styles.checkbox__invalid}>
                        {errors.terms.message}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div
                className={`col-md-12 col-lg-12 ${styles.diabConsLp__form__cta}`}
              >
                <span className="error text-center text-danger">
                  {!isValid && isSubmitted}
                </span>
                <button type="submit">
                  <span
                    className={`${
                      props.loading && styles.diabConsLp__form__ctaLoader
                    }`}
                  >
                    {props.ctaText}
                  </span>
                  <span className={styles.diabConsLp__form__loader}>
                    <Loader
                      type="TailSpin"
                      color="#FFF"
                      height={30}
                      width={30}
                      radius={1}
                      visible={props.loading}
                    />
                  </span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default FormComponent;
